import { render, staticRenderFns } from "./CopyTrading.vue?vue&type=template&id=c83a07ea&scoped=true"
import script from "./CopyTrading.vue?vue&type=script&lang=js"
export * from "./CopyTrading.vue?vue&type=script&lang=js"
import style0 from "./CopyTrading.vue?vue&type=style&index=0&id=c83a07ea&prod&scoped=true&lang=css"
import style1 from "./CopyTrading.vue?vue&type=style&index=1&id=c83a07ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c83a07ea",
  null
  
)

export default component.exports